//Name: Skills
//CODE: skills
//Age: ''
//Gender: Both
const skillsOptions = [
  { id: '0', label: 'Sports', values: [
    { id: '0', value: "AFL Football", label: "AFL Football" },
    { id: '1', value: "Stunts", label: "Stunts" },
    { id: '2', value: "Archery", label: "Archery" },
    { id: '3', value: "Circus Performer", label: "Circus Performer" },
    { id: '4', value: "Badminton", label: "Badminton" },
    { id: '5', value: "Baseball", label: "Baseball" },
    { id: '6', value: "Basketball", label: "Basketball" },
    { id: '7', value: "BMX", label: "BMX" },
    { id: '8', value: "Boxing", label: "Boxing" },
    { id: '9', value: "Chi-Quong", label: "Chi-Quong" },
    { id: '10', value: "Climbing", label: "Climbing" },
    { id: '11', value: "Cricket", label: "Cricket" },
    { id: '12', value: "Cycling", label: "Cycling" },
    { id: '13', value: "Diving", label: "Diving" },
    { id: '15', value: "Dressage", label: "Dressage" },
    { id: '16', value: "Fencing", label: "Fencing" },
    { id: '17', value: "Fly Fishing", label: "Fly Fishing" },
    { id: '18', value: "Golf", label: "Golf" },
    { id: '19', value: "Grid Iron", label: "Grid Iron" },
    { id: '20', value: "Gymnastics", label: "Gymnastics" },
    { id: '21', value: "Horse Riding", label: "Horse Riding" },
    { id: '22', value: "Ice Hockey", label: "Ice Hockey" },
    { id: '23', value: "Ice Skating", label: "Ice Skating" },
    { id: '24', value: "Jetski", label: "Jetski" },
    { id: '25', value: "Karate", label: "Karate" },
    { id: '26', value: "Kayak", label: "Kayak" },
    { id: '27', value: "Martial Arts", label: "Martial Arts" },
    { id: '28', value: "Motor Cycling", label: "Motor Cycling" },
    { id: '29', value: "Mtn. Biking", label: "Mtn. Biking" },
    { id: '30', value: "Netball", label: "Netball" },
    { id: '31', value: "Rock Climbing", label: "Rock Climbing" },
    { id: '32', value: "Roler Blading", label: "Roler Blading" },
    { id: '33', value: "Rowing", label: "Rowing" },
    { id: '34', value: "Rugby", label: "Rugby" },
    { id: '35', value: "Running", label: "Running" },
    { id: '36', value: "Sailing", label: "Sailing" },
    { id: '37', value: "Scuba Diving", label: "Scuba Diving" },
    { id: '38', value: "Skateboarding", label: "Skateboarding" },
    { id: '39', value: "Skiing", label: "Skiing" },
    { id: '40', value: "Snowboarding", label: "Snowboarding" },
    { id: '41', value: "Soccer", label: "Soccer" },
    { id: '42', value: "Squash", label: "Squash" },
    { id: '43', value: "Surfing", label: "Surfing" },
    { id: '44', value: "Swimming", label: "Swimming" },
    { id: '45', value: "Tennis", label: "Tennis" },
    { id: '46', value: "Tai Chi", label: "Tai Chi" },
    { id: '47', value: "Water Skiing", label: "Water Skiing" },
    { id: '48', value: "Wind Surfing", label: "Wind Surfing" },
    { id: '49', value: "Wrestling", label: "Wrestling" },
    { id: '50', value: "Yoga", label: "Yoga" },
    { id: '51', value: "Hockey", label: "Hockey" },
    { id: '52', value: "Touch Rugby", label: "Touch Rugby" },
    { id: '53', value: "Parachuting", label: "Parachuting" },
    { id: '54', value: "Hand gliding", label: "Hand gliding" },
    { id: '55', value: "Para sailing", label: "Para sailing" },
    { id: '56', value: "Paddle Board", label: "Paddle Board" },
    { id: '57', value: "Surf Life saving", label: "Surf Life saving" },
    { id: '58', value: "Motor racing", label: "Motor racing" },
    { id: '59', value: "Rugby League", label: "Rugby League" }
  ]},
  { id: '1', label: 'Dance', values: [
    { id: '0', value: "Aerobics", label: "Aerobics" },
    { id: '1', value: "Ballet", label: "Ballet" },
    { id: '2', value: "Ballroom", label: "Ballroom" },
    { id: '3', value: "Belly", label: "Belly" },
    { id: '4', value: "Break", label: "Break" },
    { id: '5', value: "Cabaret", label: "Cabaret" },
    { id: '6', value: "Choreography", label: "Choreography" },
    { id: '7', value: "Country", label: "Country" },
    { id: '8', value: "Flamenco", label: "Flamenco" },
    { id: '9', value: "Folkg", label: "Folk" },
    { id: '10', value: "Greek", label: "Greek" },
    { id: '11', value: "Highland", label: "Highland" },
    { id: '12', value: "Hip Hop", label: "Hip Hop" },
    { id: '13', value: "Irish Step", label: "Irish Step" },
    { id: '15', value: "Jazz", label: "Jazz" },
    { id: '16', value: "Jive", label: "Jive" },
    { id: '17', value: "Latin", label: "Latin" },
    { id: '18', value: "Modern", label: "Modern" },
    { id: '19', value: "Old Time", label: "Old Time" },
    { id: '20', value: "Period", label: "Period" },
    { id: '21', value: "Swing", label: "Swing" },
    { id: '22', value: "Tap", label: "Tap" },
    { id: '23', value: "Traditional", label: "Traditional" },
    { id: '25', value: "Kapa Haka", label: "Kapa Haka" },
    { id: '26', value: "Cook Island Dance", label: "Cook Island Dance" },
    { id: '27', value: "Samoan Dance", label: "Samoan Dance" },
    { id: '28', value: "Tongan Dance", label: "Tongan Dance" },
    { id: '29', value: "Indian Dance", label: "Indian Dance" },
    { id: '30', value: "Contemporary", label: "Contemporary" },
    { id: '31', value: "Rock n Roll", label: "Rock n Roll" },
    { id: '32', value: "Ceroc", label: "Ceroc" },
    { id: '33', value: "Tango", label: "Tango" },
    { id: '35', value: "Rumba", label: "Rumba" },
    { id: '36', value: "Pole dancing", label: "Pole dancing" }
  ]},
  { id: '2', label: 'Voice', values: [
    { id: '0', value: "Alto", label: "Alto" },
    { id: '1', value: "Ballad", label: "Ballad" },
    { id: '2', value: "Baritone", label: "Baritone" },
    { id: '3', value: "Bass", label: "Bass" },
    { id: '4', value: "Bass - Baritone", label: "Bass - Baritone" },
    { id: '5', value: "Blues", label: "Blues" },
    { id: '6', value: "C. Soprano", label: "C. Soprano" },
    { id: '7', value: "Cabaret", label: "Cabaret" },
    { id: '8', value: "Choral", label: "Choral" },
    { id: '9', value: "Contralto", label: "Contralto" },
    { id: '10', value: "Counter Tenor", label: "Counter Tenor" },
    { id: '11', value: "Country & Western", label: "Country & Western" },
    { id: '12', value: "Female Tenor", label: "Female Tenor" },
    { id: '13', value: "Folk", label: "Folk" },
    { id: '15', value: "General", label: "General" },
    { id: '16', value: "Jazz", label: "Jazz" },
    { id: '17', value: "Lyric Soprano", label: "Lyric Soprano" },
    { id: '18', value: "Mezzo", label: "Mezzo" },
    { id: '19', value: "Mezzo Soprano", label: "Mezzo Soprano" },
    { id: '20', value: "Musical", label: "Musical" },
    { id: '21', value: "Opera", label: "Opera" },
    { id: '22', value: "Popular", label: "Popular" },
    { id: '23', value: "Rock", label: "Rock" },
    { id: '24', value: "Show", label: "Show" },
    { id: '25', value: "Soprano", label: "Soprano" },
    { id: '26', value: "Tenor", label: "Tenor" }
  ]},
  { id: '3', label: 'Instrumental', values: [
    { id: '0', value: "Accordian", label: "Accordian" },
    { id: '1', value: "Bagpipes", label: "Bagpipes" },
    { id: '2', value: "Banjo", label: "Banjo" },
    { id: '3', value: "Bassoon", label: "Bassoon" },
    { id: '4', value: "Cello", label: "Cello" },
    { id: '5', value: "Clarinet", label: "Clarinet" },
    { id: '6', value: "Concertina", label: "Concertina" },
    { id: '7', value: "Didgerdoo", label: "Didgerdoo" },
    { id: '8', value: "Double Bass", label: "Double Bass" },
    { id: '9', value: "Drums", label: "Drums" },
    { id: '10', value: "Electric Bass", label: "Electric Bass" },
    { id: '11', value: "Euphonium", label: "Euphonium" },
    { id: '12', value: "Flute", label: "Flute" },
    { id: '13', value: "French Horn", label: "French Horn" },
    { id: '15', value: "Guitar", label: "Guitar" },
    { id: '16', value: "Harmonica", label: "Harmonica" },
    { id: '17', value: "Harp", label: "Harp" },
    { id: '18', value: "Horn", label: "Horn" },
    { id: '19', value: "Keyboard", label: "Keyboard" },
    { id: '20', value: "Mandolin", label: "Mandolin" },
    { id: '21', value: "Oboe", label: "Oboe" },
    { id: '22', value: "Organ", label: "Organ" },
    { id: '23', value: "Percussion", label: "Percussion" },
    { id: '24', value: "Piano", label: "Piano" },
    { id: '25', value: "Piccolo", label: "Piccolo" },
    { id: '26', value: "Recorder", label: "Recorder" },
    { id: '27', value: "Saxophone", label: "Saxophone" },
    { id: '28', value: "Sitar", label: "Sitar" },
    { id: '29', value: "Trombone", label: "Trombone" },
    { id: '30', value: "Trumpet", label: "Trumpet" },
    { id: '31', value: "Tuba", label: "Tuba" },
    { id: '32', value: "Ukuele", label: "Ukuele" },
    { id: '33', value: "Viola", label: "Viola" },
    { id: '34', value: "Violin", label: "Violin" },
    { id: '35', value: "Wood Wind", label: "Wood Wind" },
    { id: '36', value: "Zither", label: "Zither" }
  ]},
  { id: '4', label: 'Accents', values: [
    { id: '0', value: "Aboriginal", label: "Aboriginal" },
    { id: '1', value: "African", label: "African" },
    { id: '2', value: "American - Californian", label: "American - Californian" },
    { id: '3', value: "American - Midwest", label: "American - Midwest" },
    { id: '4', value: "American - New England", label: "American - New England" },
    { id: '5', value: "American - New York", label: "American - New York" },
    { id: '6', value: "American - Southern States", label: "American - Southern States" },
    { id: '7', value: "American - Standard", label: "American - Standard" },
    { id: '8', value: "American - Urban", label: "American - Urban" },
    { id: '9', value: "American - Western States", label: "American - Western States" },
    { id: '10', value: "Arab", label: "Arab" },
    { id: '11', value: "Asian", label: "Asian" },
    { id: '12', value: "Australian", label: "Australian" },
    { id: '13', value: "Canadian", label: "Canadian" },
    { id: '15', value: "Caribbean", label: "Caribbean" },
    { id: '16', value: "Chinese", label: "Chinese" },
    { id: '17', value: "Danish", label: "Danish" },
    { id: '18', value: "Dutch", label: "Dutch" },
    { id: '19', value: "East European", label: "East European" },
    { id: '20', value: "French", label: "French" },
    { id: '21', value: "German", label: "German" },
    { id: '22', value: "Greek", label: "Greek" },
    { id: '23', value: "Indian", label: "Indian" },
    { id: '24', value: "Italian", label: "Italian" },
    { id: '25', value: "Japanese", label: "Japanese" },
    { id: '26', value: "Latin American", label: "Latin American" },
    { id: '27', value: "Mexican", label: "Mexican" },
    { id: '28', value: "Middle Eastern", label: "Middle Eastern" },
    { id: '29', value: "New Zealand", label: "New Zealand" },
    { id: '30', value: "Pakistani", label: "Pakistani" },
    { id: '31', value: "Polish", label: "Polish" },
    { id: '32', value: "Russian", label: "Russian" },
    { id: '33', value: "Scandinavian", label: "Scandinavian" },
    { id: '34', value: "South African", label: "South African" },
    { id: '35', value: "Spanish", label: "Spanish" },
    { id: '36', value: "UK - Cockney", label: "UK - Cockney" },
    { id: '37', value: "UK - English", label: "UK - English" },
    { id: '38', value: "UK - Irish", label: "UK - Irish" },
    { id: '39', value: "UK - Scottish", label: "UK - Scottish" },
    { id: '40', value: "Portuguese", label: "Portuguese" },
    { id: '41', value: "Maori", label: "Maori" },
    { id: '42', value: "Polynesian", label: "Polynesian" },
    { id: '43', value: "Welsh", label: "Welsh" }
  ]},
  { id: '5', label: 'Languages', values: [
    { id: '0', value: "Aborigine - Australian Aboriginal", label: "Aborigine - Australian Aboriginal" },
    { id: '1', value: "Aborigine - Inuit", label: "Aborigine - Inuit" },
    { id: '2', value: "Aborigine - Maori", label: "Aborigine - Maori" },
    { id: '3', value: "Aborigine - Native American", label: "Aborigine - Native American" },
    { id: '4', value: "African - Senegalese", label: "African - Senegalese" },
    { id: '5', value: "African - Swaheli", label: "African - Swaheli" },
    { id: '6', value: "Afrikaans", label: "Afrikaans" },
    { id: '7', value: "Asian - Cantonese", label: "Asian - Cantonese" },
    { id: '8', value: "Asian - Indonesian", label: "Asian - Indonesian" },
    { id: '9', value: "Asian - Japanese", label: "Asian - Japanese" },
    { id: '10', value: "Asian - Korean", label: "Asian - Korean" },
    { id: '11', value: "Asian - Malay", label: "Asian - Malay" },
    { id: '12', value: "Asian - Mandarin", label: "Asian - Mandarin" },
    { id: '13', value: "Asian - Filipino - Tagalog", label: "Asian - Filipino - Tagalog" },
    { id: '15', value: "Asian - Filipino - Cebuano", label: "Asian - Filipino - Cebuano" },
    { id: '16', value: "Asian - Singaporean", label: "Asian - Singaporean" },
    { id: '17', value: "Asian - Thai", label: "Asian - Thai" },
    { id: '18', value: "Eastern - Arabic", label: "Eastern - Arabic" },
    { id: '19', value: "Eastern - Bengali", label: "Eastern - Bengali" },
    { id: '20', value: "Eastern - Farsi", label: "Eastern - Farsi" },
    { id: '21', value: "Eastern - Fukien", label: "Eastern - Fukien" },
    { id: '22', value: "Eastern - Gujarati", label: "Eastern - Gujarati" },
    { id: '23', value: "Eastern - Hebrew", label: "Eastern - Hebrew" },
    { id: '24', value: "Eastern - Hindi", label: "Eastern - Hindi" },
    { id: '25', value: "Eastern - Kurdish", label: "Eastern - Kurdish" },
    { id: '26', value: "Eastern - Punjabi", label: "Eastern - Punjabi" },
    { id: '27', value: "Eastern - Sinhalese", label: "Eastern - Sinhalese" },
    { id: '28', value: "Eastern - Turkish", label: "Eastern - Turkish" },
    { id: '29', value: "Eastern - Urdu", label: "Eastern - Urdu" },
    { id: '30', value: "European - Danish", label: "European - Danish" },
    { id: '31', value: "European - Dutch", label: "European - Dutch" },
    { id: '32', value: "European - English", label: "European - English" },
    { id: '33', value: "European - French", label: "European - French" },
    { id: '34', value: "European - German", label: "European - German" },
    { id: '35', value: "European - Greek", label: "European - Greek" },
    { id: '36', value: "European - Italian", label: "European - Italian" },
    { id: '37', value: "European - Portuguese", label: "European - Portuguese" },
    { id: '38', value: "European - Russian", label: "European - Russian" },
    { id: '39', value: "European - Scandanavian", label: "European - Scandanavian" },
    { id: '40', value: "European - Spanish", label: "European - Spanish" },
    { id: '41', value: "Latin", label: "Latin" },
    { id: '42', value: "Other European - Armenian", label: "Other European - Armenian" },
    { id: '43', value: "Other European - Bulgarian", label: "Other European - Bulgarian" },
    { id: '30', value: "Other European - Cornish", label: "Other European - Cornish" },
    { id: '31', value: "Other European - Croatian", label: "Other European - Croatian" },
    { id: '32', value: "Other European - Czech", label: "Other European - Czech" },
    { id: '33', value: "Other European - Esperanto", label: "Other European - Esperanto" },
    { id: '34', value: "Other European - Finnish", label: "Other European - Finnish" },
    { id: '35', value: "Other European - Flemish", label: "Other European - Flemish" },
    { id: '36', value: "Other European - Gaelic", label: "Other European - Gaelic" },
    { id: '37', value: "Other European - Hungarian", label: "Other European - Hungarian" },
    { id: '38', value: "Other European - Icelandic", label: "Other European - Icelandic" },
    { id: '39', value: "Other European - Latvian", label: "Other European - Latvian" },
    { id: '40', value: "Other European - Lithuanian", label: "Other European - Lithuanian" },
    { id: '41', value: "Other European - Macedonian", label: "Other European - Macedonian" },
    { id: '42', value: "Other European - Maltese", label: "Other European - Maltese" },
    { id: '43', value: "Other European - Polish", label: "Other European - Polish" },
    { id: '44', value: "Other European - Romanian", label: "Other European - Romanian" },
    { id: '45', value: "Other European - Serbian", label: "Other European - Serbian" },
    { id: '46', value: "Other European - Serbo-Croat", label: "Other European - Serbo-Croat" },
    { id: '47', value: "Other European - Slavonic", label: "Other European - Slavonic" },
    { id: '48', value: "Other European - Welsh", label: "Other European - Welsh" },
    { id: '49', value: "Other European - Yiddish", label: "Other European - Yiddish" },
    { id: '50', value: "Patios", label: "Patios" },
    { id: '51', value: "Romany", label: "Romany" },
    { id: '52', value: "Sign Language", label: "Sign Language" },
    { id: '53', value: "Tahitian", label: "Tahitian" },
    { id: '54', value: "Samoan", label: "Samoan" },
    { id: '55', value: "Brazilian - Portuguese", label: "Brazilian - Portuguese" }
  ]},
  { id: '6', label: 'Circus', values: [
    { id: '0', value: "Acrobatics", label: "Acrobatics" },
    { id: '1', value: "Animal Handling", label: "Animal Handling" },
    { id: '2', value: "Balancer", label: "Balancer" },
    { id: '3', value: "Clown", label: "Clown" },
    { id: '4', value: "Contortionist", label: "Contortionist" },
    { id: '5', value: "Croupier", label: "Croupier" },
    { id: '6', value: "Fire Eater", label: "Fire Eater" },
    { id: '7', value: "Impersonation", label: "Impersonation" },
    { id: '8', value: "Juggler", label: "Juggler" },
    { id: '9', value: "Magician", label: "Magician" },
    { id: '10', value: "Mime", label: "Mime" },
    { id: '11', value: "Puppetry", label: "Puppetry" },
    { id: '12', value: "Stage Combat", label: "Stage Combat" },
    { id: '13', value: "Stilt Walker", label: "Stilt Walker" },
    { id: '15', value: "Unicycle", label: "Unicycle" },
    { id: '16', value: "Ventriloquist", label: "Ventriloquist" },
    { id: '17', value: "Balloon twisting", label: "Balloon twisting" },
    { id: '18', value: "Face painting", label: "Face painting" }
  ]},
  { id: '7', label: 'Performance', values: [
    { id: '0', value: "After Dinner Speaking", label: "After Dinner Speaking" },
    { id: '1', value: "Comedy", label: "Comedy" },
    { id: '2', value: "Commentating", label: "Commentating" },
    { id: '3', value: "Disc Jockey", label: "Disc Jockey" },
    { id: '4', value: "Master of Ceremonies", label: "Master of Ceremonies" },
    { id: '5', value: "Musical Comedy", label: "Musical Comedy" },
    { id: '6', value: "Professional Musician", label: "Professional Musician" },
    { id: '7', value: "Professional Singer", label: "Professional Singer" },
    { id: '8', value: "Radio Presenting", label: "Radio Presenting" },
    { id: '9', value: "Stand Up Comic", label: "Stand Up Comic" },
    { id: '10', value: "TV Presenting", label: "TV Presenting" },
    { id: '11', value: "Voice Over", label: "Voice Over" },
    { id: '12', value: "Runway", label: "Runway" },
    { id: '13', value: "Body Work", label: "Body Work" },
    { id: '14', value: "Drama", label: "Drama" },
    { id: '15', value: "Children's entertainer", label: "Children's entertainer" },
    { id: '16', value: "Story teller", label: "Story teller" },
    { id: '17', value: "Narrator", label: "Narrator" },
    { id: '18', value: "Talkback Host", label: "Talkback Host" },
    { id: '19', value: "Radio Drama", label: "Radio Drama" },
    { id: '20', value: "Web Presenter", label: "Web Presenter" },
    { id: '21', value: "Video game voicing", label: "Video game voicing" },
    { id: '22', value: "Looping", label: "Looping" },
    { id: '23', value: "Auto cue", label: "Auto cue" },
    { id: '24', value: "Live promotional", label: "Live promotional" },
    { id: '25', value: "Improvised role play", label: "Improvised role play" },
    { id: '26', value: "Voicing for Animation", label: "Voicing for Animation" },
    { id: '27', value: "Musical Theatre", label: "Musical Theatre" },
    { id: '28', value: "Professional Theatre", label: "Professional Theatre" },
    { id: '29', value: "Lip Syncing", label: "Lip Syncing" }
  ]},
];  

export default skillsOptions;


// WEBPACK FOOTER //
// ./src/data/skills.js